import React from "react";
import { FiFacebook, FiInstagram, FiTwitch } from "react-icons/fi";

const Footer = () => {
    return (
        <div className="p-5 lg:px-10 bg-white py-10">

            <div className="flex flex-col md:flex-row justify-between w-[90%] mx-auto">

                <div className="flex flex-col gap-2 w-full  md:mb-0 ">
                    <h2 className="tracking-wider mb text-lg text-center sm:text-left">Address</h2>
                    <ul className="list-disc space-y-2">
                        <li> <p className="text-gray-500">64လမ်း 109B-110ကြား ပန်းရောင်တိုက်အောက်က
                            အဖြူရောင်ဆိုင်လေး/ချမ်းမြသာစည် /မန်းလေးမြို့</p></li>
                        <li>   <p className="text-gray-500"> No.292/1A ရွှေတိဂုံဘုရားလမ်း Junction city အနီး
                            ဒဂုံပန်းခြံရှေ့ ဒဂုံမြို့နယ် /ရန်ကုန်မြို့</p></li>
                        <li>  <p className="text-gray-500">လှည်းတန်းCenter ဘေး M Tower -Bloom Store</p></li>
                    </ul>

                </div>
                <div className="ml-auto gap-2 w-full mb-5 space-y-2 sm:space-y-3 md:mb-0 text-center place-content-center">
                    <h2 className="tracking-wider text-lg">Contact Us</h2>
                    <p className=" text-gray-500">+95 9 44404 3483</p>
                    <p className="text-gray-500">elfinstudio21@gmail.com</p>
                </div>

            </div>
            <div className="w-[90%] h-px bg-black mx-auto my-2 "></div>
            <div className="flex flex-col md:flex-row  gap-5 justify-between w-[90%] mx-auto ">
                <p className=" text-xs text-gray-500 order-2 md:order-1">
                    CopyRight &copy; {`${new Date().getFullYear()} , Elfin Studio`}
                </p>
                <div className="flex gap-4 order-1 md:order-2">
                    <FiFacebook className="cursor-pointer" />
                    <FiInstagram className="cursor-pointer" />
                    {/* <FiYoutube className="cursor-pointer" /> */}
                    <FiTwitch className="cursor-pointer" />
                </div>
            </div>
        </div>
    );
};

export default Footer;
